import { GridCellProps } from "@progress/kendo-react-grid";

export const BooleanCell = (props: GridCellProps) => {
  return (
    <td
      aria-colindex={props.columnIndex}
      role="gridcell"
    >
      {props.dataItem[props.field!] ? "Oui" : "Non"}
    </td>
  );
};